import Component from './component.vue';

export default Component;



// WEBPACK FOOTER //
// ./src/components/spinners/inlearno/index.ts